/*eslint-disable no-undef*/

import React, { Component } from 'react';
import '../App.css';

class Login extends Component {
  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('umd');
    this.state = {value: myParam ? myParam : "",
                  identified: false};
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount(){
    if(this.state.value !== "" && !this.state.identified){
      this.handleSubmit();
    }
  }
  componentDidMount () {
    deeploop.page();
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }
  handleSubmit() {
    var deeploop = window.deeploop = window.deeploop || [];
    deeploop.identify({
      email: this.state.value
    });
    this.setState({identified: true})
  }

  render() {
    return (
      !this.state.identified && <div className="login-page">
        <div className="form">
            <form className="login-form"
            onSubmit={this.handleSubmit}>
            <input type="email" placeholder="email" value={this.state.value} onChange={this.handleChange}/>
            <input type="password" placeholder="password"/>
            <button>login</button>
            </form>
        </div>
      </div>
    )
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.jsx